import { JSX } from 'react';
import { N07CorporateFooterProps } from './N07CorporateFooter.types';
import { CorporateFooter } from '@ahc-digital/component-library';
import { CreateCorporatefooterModel } from './N07CorporateFooter.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: N07CorporateFooterProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <CorporateFooter
      data-component={marketingRenderingName}
      {...CreateCorporatefooterModel(props)}
    />
  );
};

export default checkDatasourceForRendering<N07CorporateFooterProps>(Default);
